import { useEffect, useRef } from 'react';

// 监听窗口变化事假
function useResizeChange(handler: Function, delay = 300) {
  const timer = useRef<any>();
  useEffect(() => {
    const listener = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        handler();
      }, delay);
    };
    window.addEventListener('resize', listener);
    return () => {
      window.removeEventListener('resize', listener);
    };
  }, [handler]);
}

export default useResizeChange;
